import React from 'react';
import { Box, Typography } from '@mui/material';

const NotFound = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      minHeight="60vh"
      p={4}
    >
      <img
        src="/assets/images/404.png"
        alt="404 Not Found"
        style={{ maxWidth: 'auto', height: 450, marginBottom: '20px' }}
      />
      <Typography variant="h5" color="text.secondary">
        Oops! The page you're looking for doesn't exist.
      </Typography>
    </Box>
  );
};

export default NotFound;
